<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Keywords Advance</h3>
      </div>
    </div>
  </div>
</div>

<table  class="table table-striped table-bordered mt-3" style="width:100%">
  <thead >
    <tr class="thead-dark">
      <th class="text-center">Label</th>
      <th class="text-left">Operation</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Keyword Template</td>
      <td>
        <a href="http://payres.intelligent-earnings.com/templates/upload_keyword_template.xlsx" target="_blank"  >Download</a>
      </td>
    </tr>
    <tr>
      <td>Upload Keyword</td>
      <td class="controls form-inline">
        <input type="file" class="form-control" (change)="onKeywordFileChange($event)" accept=".xlsx" id="keywordFileId" />
        <button class="btn btn-success btn-sm mr-2" (click)="uploadKeywords()" *ngIf="!keywordUploading">Upload</button>
        <button class="btn btn-success btn-sm mr-2" *ngIf="keywordUploading" disabled>Uploading</button>
        <button class="btn btn-success btn-sm mr-2 d-none" id="uploadResultBtn" (click)="openModal(viewUploaddResult)">Open</button>
      </td>
    </tr>
    <tr>
      <td>Affiliate Template</td>
      <td>
        <a href="http://payres.intelligent-earnings.com/templates/upload_affiliate_template.xlsx" target="_blank" >Download</a>
      </td>
    </tr>
    <tr>
      <td>Upload Affiliate</td>
      <td class="controls form-inline">
        <input type="file" class="form-control"  (change)="onAffiliateFileChange($event)" accept=".xlsx" id="affiliateFileId" />
        <button class="btn btn-success btn-sm mr-2" (click)="uploadAffiliates()" *ngIf="!affiliateUploading">Upload</button>
        <button class="btn btn-success btn-sm mr-2" *ngIf="affiliateUploading" disabled>Uploading</button>
      </td>
    </tr>
  </tbody>
</table>

<ng-template #viewUploaddResult let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="uploadedResultUrl-header">Uploaded Result</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to download:
        <a href={{uploadResultUrl}} target="_blank">
          {{uploadResultUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
